export default {
	SupOnlyDownList: [],
	Total: 0,
	IsLoading: false
};
